const TITLE_CONFIGS = [
  {
    key: "title1",
    group: "main",
    number: 1,
    numberLabel: "Титул 1",
    role: "Грузоотправитель",
    title: "Данные грузоотправителя",
    description: "Исходные сведения ЭТрН: участники, груз, маршрут, транспорт и водитель.",
  },
  {
    key: "title2",
    group: "main",
    number: 2,
    numberLabel: "Титул 2",
    role: "Перевозчик при приёмке",
    title: "Приём груза к перевозке",
    description: "Факт приёмки груза перевозчиком, замечания и подпись при погрузке.",
  },
  {
    key: "title3",
    group: "main",
    number: 3,
    numberLabel: "Титул 3",
    role: "Грузополучатель",
    title: "Приёмка груза получателем",
    description: "Результат доставки, расхождения, частичная приёмка или отказ.",
  },
  {
    key: "title4",
    group: "main",
    number: 4,
    numberLabel: "Титул 4",
    role: "Перевозчик при сдаче",
    title: "Сдача груза перевозчиком",
    description: "Завершающий титул перевозчика после оформления приёмки грузополучателем.",
  },
  {
    key: "redirect",
    group: "additional",
    number: 7,
    numberLabel: "Титул 7",
    role: "Перевозчик",
    title: "Переадресовка",
    description: "Дополнительный сценарий ЭТрН, если меняется адрес выгрузки или получатель.",
  },
  {
    key: "replacement",
    group: "additional",
    number: 44,
    numberLabel: "Титул 8",
    role: "Перевозчик",
    title: "Замена водителя или ТС",
    description: "Дополнительный сценарий ЭТрН, если после приёмки меняется водитель или транспорт.",
  },
];

// Возвращает только описание и реальные записи титулов. Статусы и действия
// принадлежат backend document_flow и намеренно здесь не вычисляются.
export function consignmentNoteTitleDefinitions(document = {}) {
  const titles = consignmentNoteTitles(document);

  return TITLE_CONFIGS.map((config) => {
    const title = titles.find((item) => Number(item.number) === config.number);

    return {
      ...config,
      titleRecord: title || null,
    };
  });
}

function consignmentNoteTitles(document) {
  if (Array.isArray(document.consignment_note_titles)) {
    return document.consignment_note_titles;
  }

  return Array.isArray(document.titles) ? document.titles : [];
}
